module.exports = __webpack_public_path__ + "img/dogeos.4f0226b8.svg";